var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 26.6666H8.66659C6.64436 26.6666 4.91681 25.9666 3.48392 24.5666C2.05103 23.1666 1.33414 21.4555 1.33325 19.4333C1.33325 17.6999 1.85547 16.1555 2.89992 14.7999C3.94436 13.4444 5.31103 12.5777 6.99992 12.1999C7.55547 10.1555 8.66659 8.49992 10.3333 7.23325C11.9999 5.96659 13.8888 5.33325 15.9999 5.33325C18.5999 5.33325 20.8057 6.23903 22.6173 8.05059C24.4288 9.86214 25.3341 12.0675 25.3333 14.6666C26.8666 14.8444 28.139 15.5057 29.1506 16.6506C30.1621 17.7955 30.6675 19.1341 30.6666 20.6666C30.6666 22.3333 30.0835 23.7501 28.9173 24.9173C27.751 26.0844 26.3341 26.6675 24.6666 26.6666H17.3333V17.1333L19.4666 19.1999L21.3333 17.3333L15.9999 11.9999L10.6666 17.3333L12.5333 19.1999L14.6666 17.1333V26.6666Z",
    fill: "#00A300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/S3.d38b6917e428bf438e5bc51a618147d3.svg";
export { ForwardRef as ReactComponent };